<template>
  <section ref="serviceSection" class="service-section">
    <div class="label center">{{ content.label }}</div>
    <h2 class="center">{{ content.title }}</h2>
    <div class="service grid-2-col">
      <div
        v-for="(service, index) in content.items"
        :key="index"
        class="service__item"
        :class="{ 'fade-in': showItems[index] }"
        :style="{ transitionDelay: `${index * 200}ms` }"
      >
        <div class="service__icon">
          <img :src="`/img/icons/${service.icon}`" alt="Service icon" class="icon" />
        </div>
        <h3>{{ service.title }}</h3>
        <div class="service__description">{{ service.description }}</div>
      </div>
    </div>
  </section>
</template>

<script>
import { watch } from 'vue';

export default {
  name: 'ServicesSection',
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showItems: [] // Контролируем появление каждого элемента
    };
  },
  mounted() {
    this.initIntersectionObserver();
    this.startObserver();
  },
  methods: {
    initIntersectionObserver() {
      const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          this.showItems = this.content.items.map(() => true);
          observer.disconnect();
        }
      }, { threshold: 0.3 });

      observer.observe(this.$refs.serviceSection);
    },
    startObserver() {
      watch(
        () => this.$i18n.locale,
        () => {
          this.showItems = []; // Сбрасываем анимацию
          this.$nextTick(() => {
            this.initIntersectionObserver(); // Перезапускаем наблюдатель
          });
        }
      );
    }
  }
};
</script>


